import { Component } from '@angular/core';
import { CanWriteTdRatesComponent } from './can-write-td-rates.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'eaa-td-rates-nav-menu',
  imports: [CanWriteTdRatesComponent, RouterLink],
  template: `
    <eaa-can-write-td-rates>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="bi bi-percent" aria-hidden="true"></span> TD RATES
        </a>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" [routerLink]="['/td-rates']">TD RATES</a>
            <a class="dropdown-item" [routerLink]="['/td-rates', 'banks']">BANKS</a>
            <a class="dropdown-item" [routerLink]="['/td-rates', 'fiduciaries']">FIDUCIARIES</a>
          </li>
        </ul>
      </li>
    </eaa-can-write-td-rates>
  `
})
export class TdRatesNavMenuComponent {}
